import { styled } from 'linaria/react';

export const Container = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  column-gap: var(--space-100);
  width: 100%;
  padding: var(--space-150) var(--space-200);
`;

export const BrandItem = styled.div`
  --container-width: 100px;
  --container-height: 68px;

  --img-width: 96px;
  --img-height: 64px;

  @media (--only-mobile) {
    --container-width: 76px;
    --container-height: 52px;

    --img-width: 72px;
    --img-height: 48px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--container-width);
  width: var(--container-width);
  height: var(--container-height);
  border-radius: var(--space-50);
  box-shadow: var(--box-shadow-s);

  & picture {
    width: var(--img-width);
    height: var(--img-height);
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
`;

export const BrandItemLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
